import { useEffect, useState, useCallback } from "react";
import { Download, Printer } from "lucide-react";
import api, { API, fmtRp } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/ui-kit";

export default function Reports() {
  const [summary, setSummary] = useState(null);
  const [range, setRange] = useState({ start: "", end: "" });

  const params = new URLSearchParams();
  if (range.start) params.set("start", range.start);
  if (range.end) params.set("end", range.end);
  const qs = params.toString() ? `?${params.toString()}` : "";

  const load = useCallback(() => {
    api.get(`/reports/summary${qs}`).then((r) => setSummary(r.data)).catch(() => {});
  }, [qs]);
  useEffect(() => { load(); }, [load]);

  const download = (path) => {
    window.location.href = `${API}${path}${qs}`;
  };

  return (
    <div data-testid="reports-page">
      <PageHeader
        kicker="Pelaporan Keuangan"
        title="Laporan Koperasi"
        desc="Ringkasan kas, transaksi, piutang, simpan pinjam, lelang, dan mutasi inventori."
        action={<button onClick={() => window.print()} className="tap btn-outline px-5 font-semibold flex items-center gap-2"><Printer size={18} /> Print</button>}
      />

      <div className="border hairline p-5 mb-8 flex flex-col md:flex-row gap-3 md:items-end">
        <div>
          <label className="mono-label">Mulai</label>
          <input type="date" className="field tap px-4 mt-2" value={range.start} onChange={(e) => setRange({ ...range, start: e.target.value })} />
        </div>
        <div>
          <label className="mono-label">Selesai</label>
          <input type="date" className="field tap px-4 mt-2" value={range.end} onChange={(e) => setRange({ ...range, end: e.target.value })} />
        </div>
        <button onClick={load} className="tap btn-primary px-5 font-semibold">Terapkan Filter</button>
        <div className="flex flex-wrap gap-2 md:ml-auto">
          <button onClick={() => download("/reports/transactions.csv")} className="btn-outline px-3 py-2 text-sm font-semibold"><Download size={14} className="inline mr-1" /> Transaksi CSV</button>
          <button onClick={() => download("/reports/loans.csv")} className="btn-outline px-3 py-2 text-sm font-semibold"><Download size={14} className="inline mr-1" /> Pinjaman CSV</button>
          <button onClick={() => download("/reports/inventory.csv")} className="btn-outline px-3 py-2 text-sm font-semibold"><Download size={14} className="inline mr-1" /> Inventori CSV</button>
        </div>
      </div>

      {summary && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-px bg-[var(--line)] border hairline mb-8">
            <Cell><StatCard label="Kas Masuk" value={fmtRp(summary.cash_in)} /></Cell>
            <Cell><StatCard label="Kas Keluar" value={fmtRp(summary.cash_out)} index={1} /></Cell>
            <Cell><StatCard label="Kas Bersih" value={fmtRp(summary.net_cash)} index={2} danger={summary.net_cash < 0} /></Cell>
            <Cell><StatCard label="Piutang Aktif" value={fmtRp(summary.active_debt)} index={3} danger={summary.active_debt > 0} /></Cell>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-px bg-[var(--line)] border hairline">
            <Mini label="BBM diterima" value={fmtRp(summary.bbm_revenue)} />
            <Mini label="Bruto lelang ikan" value={fmtRp(summary.fish_sales_gross)} />
            <Mini label="Simpanan masuk" value={fmtRp(summary.savings_in)} />
            <Mini label="Pinjaman dicairkan" value={fmtRp(summary.loan_disbursed)} />
            <Mini label="Cicilan pinjaman" value={fmtRp(summary.loan_payments)} />
            <Mini label="Mutasi stok" value={summary.inventory_movements} />
          </div>
        </>
      )}
    </div>
  );
}

function Mini({ label, value }) {
  return <div className="bg-white p-5"><p className="mono-label">{label}</p><p className="font-bold text-2xl mt-2">{value}</p></div>;
}

const Cell = ({ children }) => <div className="bg-white">{children}</div>;
